(function () {
  'use strict';

  /* ══════════════════════════════════════════
     CONFIG
     ══════════════════════════════════════════ */
  var GROUPED_HANDLES = ['size'];          // option handles to group
  var SIZE_CHART_IMAGE = null;             // e.g. 'https://.../chart.png' — null = no chart
  var SIZE_CHART_TITLE = 'Size Chart';

  var SELECT_FIRST_GROUP_VALUE = true;     // auto-select 1st available value of 1st group
  var RESPECT_VARIANT_URL = false;         // true = keep ?variant= links (shared/collection links)

  var CATEGORIES = ['TODDLER', 'YOUTH', 'GIRLS', 'BOYS', 'WOMEN', 'MEN', 'ADULT'];

  /* ══════════════════════════════════════════
     SIZE CHART MODAL (built once, on demand)
     ══════════════════════════════════════════ */
  var modal;
  function openModal(src, title) {
    if (!src) return;
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'flite-modal-overlay';
      modal.innerHTML =
        '<div class="flite-modal">' +
          '<button class="flite-modal-close" type="button">&times;</button>' +
          '<div class="flite-modal-title"></div>' +
          '<img class="flite-modal-img" src="" alt="Size Chart">' +
        '</div>';
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.classList.contains('flite-modal-close')) {
          modal.classList.remove('open');
        }
      });
      document.body.appendChild(modal);
    }
    modal.querySelector('.flite-modal-img').src = src;
    modal.querySelector('.flite-modal-title').textContent = title || 'Size Chart';
    modal.classList.add('open');
  }

  /* ══════════════════════════════════════════
     SELECT FIRST AVAILABLE OPTION (grouped order)
     ══════════════════════════════════════════ */
  function selectFirstGroupValue(select) {
    if (!SELECT_FIRST_GROUP_VALUE || !select) return;
    if (RESPECT_VARIANT_URL && /[?&]variant=/.test(window.location.search)) return;
    if (select.dataset.fliteUserPicked) return; // never override a customer's choice

    var opts = Array.prototype.slice.call(select.options);
    var first = opts.find(function (o) { return !o.disabled; });
    if (!first) return;

    opts.forEach(function (o) {
      o.selected = false;
      o.removeAttribute('selected');
    });
    first.setAttribute('selected', 'selected');
    first.selected = true;
    select.selectedIndex = opts.indexOf(first);
    select.value = first.value;

    // Tell the theme so price / variant ID / URL update
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ══════════════════════════════════════════
     GROUP OPTIONS INSIDE THE SAME SELECT
     (keeps theme bindings)
     ══════════════════════════════════════════ */
  function groupSelect(select) {
    if (!select || select.dataset.fliteGrouped || select.querySelector('optgroup')) return;

    var opts = Array.prototype.slice.call(select.options);
    if (!opts.length) return;

    // Bucket options by category prefix
    var buckets = {}, other = [];
    CATEGORIES.forEach(function (c) { buckets[c] = []; });

    opts.forEach(function (o) {
      var val = (o.value || '').toUpperCase();
      var cat = CATEGORIES.find(function (c) { return val.indexOf(c) === 0; });
      (cat ? buckets[cat] : other).push(o);
    });

    var populated = CATEGORIES.filter(function (c) { return buckets[c].length; }).length;
    if (populated < 2) return; // not worth grouping

    // Rebuild via fragment (single reflow)
    var frag = document.createDocumentFragment();
    function addGroup(label, items) {
      if (!items.length) return;
      var og = document.createElement('optgroup');
      og.label = '── ' + label + ' ──';
      items.forEach(function (o) { og.appendChild(o); }); // move existing nodes
      frag.appendChild(og);
    }
    CATEGORIES.forEach(function (c) {
      addGroup(c.charAt(0) + c.slice(1).toLowerCase(), buckets[c]);
    });
    addGroup('Other', other);

    select.appendChild(frag);
    select.dataset.fliteGrouped = '1';

    // Track real customer selections so we never override them
    select.addEventListener('change', function (e) {
      if (e.isTrusted) select.dataset.fliteUserPicked = '1';
    });

    // Defer so the theme's variant listeners are attached first
    setTimeout(function () { selectFirstGroupValue(select); }, 0);
  }

  /* ══════════════════════════════════════════
     SIZE CHART LINK
     ══════════════════════════════════════════ */
  function addChartLink(wrap) {
    if (!SIZE_CHART_IMAGE) return;
    var box = wrap.closest('.variant-wrapper');
    var label = box && box.querySelector('.variant__label');
    if (!label || label.querySelector('.flite-size-chart-link')) return;

    var link = document.createElement('span');
    link.className = 'flite-size-chart-link';
    link.textContent = 'Size Chart';
    link.addEventListener('click', function () {
      openModal(SIZE_CHART_IMAGE, SIZE_CHART_TITLE);
    });
    label.appendChild(link);
  }

  /* ══════════════════════════════════════════
     MAIN
     ══════════════════════════════════════════ */
  function enhance() {
    document.querySelectorAll('.variant-input-wrap[data-handle]').forEach(function (wrap) {
      var handle = (wrap.getAttribute('data-handle') || '').toLowerCase();
      if (GROUPED_HANDLES.indexOf(handle) === -1) return;

      var select = wrap.querySelector('select[data-variant-input]');
      if (!select) return;

      try {
        groupSelect(select);
        addChartLink(wrap);
      } catch (err) {
        console.error('[FLITE] size group error:', err);
      }
    });
  }

  function reapplyDefaults() {
    document.querySelectorAll('select[data-flite-grouped]').forEach(selectFirstGroupValue);
  }

  /* ══════════════════════════════════════════
     INIT
     ══════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  // Theme JS may reset the select after init — re-apply once everything has loaded
  window.addEventListener('load', function () {
    enhance();
    setTimeout(reapplyDefaults, 300);
  });

  document.addEventListener('page:loaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();